module.exports = __webpack_public_path__ + "static/media/icon_ceramic_metal_8.703b5747.svg";